import * as React from 'react';

interface AddIconProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
  size?: number;
}

const AddIcon: React.FC<AddIconProps> = ({color = '#000', size = 24, ...props}) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" fill={color} />
  </svg>
);

export default AddIcon;
